
import { Component, Vue, Prop, Ref, Watch } from 'vue-property-decorator'
import { iArray } from '@/common/utils'

export interface ins {
    getTags: () => string[] | number[]
}

/**
 * @prop list       纯 string| number 数组
 * @prop type       和饿了么一致
 * @prop effect     和饿了么一致
 * @prop text       添加词语
 * @prop showPlus   是否显示添加按钮
*/
@Component({
    name: 'dynamic-tags'
})
export default class extends Vue {
    @Prop({ default: [] }) private list!: string[] | number[]
    @Prop({ default: 'primary' }) private type!: string
    @Prop({ default: 'dark' }) private effect!: string
    @Prop({ default: '添加' }) private text!: string
    @Prop({ default: true }) private showPlus!: boolean
    @Ref('inputEl') private inputRef: any
    private tags: any[] = []
    private inputVisible = false
    private inputValue = ''

    @Watch('list')
    private watchList(list: string[] | number[]) {
        if (!Array.isArray(list)) return
        this.tags = list.slice()
    }

    private created() {
        this.tags = [...this.list]   
    }

    private handleClose(item: any) {
        iArray.remove(item, this.tags)
    }

    private handleInputConfirm() {
        let inputValue = this.inputValue
        if (inputValue) {
            this.tags.push(inputValue)
        }
        this.inputVisible = false
        this.inputValue = ''
    }

    private showInput() {
        this.inputVisible = true
        this.$nextTick(() => {
            this.inputRef.$refs.input.focus()
        })
    }

    getTags() {
        return this.tags
    }
}
